import styled from 'styled-components';
import { COLORS } from '../../../../../../../constants/radar';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 4px;
  margin-top: 8px;
`;

export const ColorOption = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 2px solid ${props => props.selected ? '#000' : 'transparent'};
  background-color: ${props => props.color};
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    transform: scale(1.1);
    border-color: #666;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(0,0,0,0.2);
  }
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
`;

export const Field = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
